// extracted by mini-css-extract-plugin
module.exports = {"mainWidth":"mainWidth--3-5Px","pageWrap":"pageWrap--3-uuK"};